import React from 'react'; // eslint-disable-line no-unused-vars
import PropTypes from 'prop-types'; // eslint-disable-line no-unused-vars
import { Icon } from '../../index.js';

/**
 * A form wrapper component.
 * @param props
 * @return {JSX.Element}
 * @constructor
 * @example return (
 *   <FormWrapper label="Email" icon="rnr">Content</FormWrapper>
 * );
 */
const FormWrapper = (props) => {
  const {
    children,
    className,
    label,
    icon,
  } = props;

  return (
    <div className={className} {...props}>
      {label && <label className="font-bold text-md inline-block py-1.5">{label}</label>}
      <div className="grid grid-cols-form-control-wrapper gap-4 mb-3">
        <div className="flex bg-griege-light text-beige-dark rounded p-1.5">
          {icon && <Icon name={icon} className="w-[21px] h-[21px] mx-auto"/>}
        </div>
        <div>{children}</div>
      </div>
    </div>
  );
};

FormWrapper.propTypes = {
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * Extend the styles applied to the component.
   */
  className: PropTypes.string,
  /**
   * Element placed before the children.
   */
  icon: PropTypes.string,
  /**
   * The label content.
   */
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),

};

export { FormWrapper };
